module.exports = __webpack_public_path__ + "img/SalesRevenue.8da3e30c.svg";